module.exports = __webpack_public_path__ + "img/12.8b1d9b15.png";